(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-product-information"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ck-product-information')){
 customElements.define('ck-product-information',class extends HTMLElement{
  connectedCallback(){
   if(this.initialized)return;this.initialized=true;
   this.tabs=[...this.querySelectorAll('[data-tab]')];this.panels=[...this.querySelectorAll('[data-panel]')];
   this.media=matchMedia('(min-width:990px)');this.active='description';
   this.tabs.forEach((tab,index)=>{
    tab.id=this.id+'-tab-'+tab.dataset.tab;
    tab.setAttribute('aria-controls',this.panels[index].id);
    tab.addEventListener('click',()=>{this.active=tab.dataset.tab;this.sync()});
    tab.addEventListener('keydown',event=>{
     let next=index;
     if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
     else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;
     else if(event.key==='Home')next=0;
     else if(event.key==='End')next=this.tabs.length-1;
     else return;
     event.preventDefault();this.tabs[next].click();this.tabs[next].focus();
    });
   });
   this.home=document.createComment('ck-product-information');
   this.host=this.closest('.shopify-section')||this;
   this.host.before(this.home);
   this.update=()=>{this.place();this.sync()};this.media.addEventListener('change',this.update);
   this.setAttribute('data-ready','');this.place();this.sync();
  }
  place(){
   const gallery=document.querySelector('.product__media-wrapper');
   const target=this.media.matches&&gallery?gallery:this.home.parentNode;
   if(!target)return;
   const docked=this.media.matches&&!!gallery;
   this.relocating=true;
   if(docked&&this.host.parentNode!==target)target.append(this.host);
   else if(!docked&&this.host.previousSibling!==this.home)this.home.after(this.host);
   this.classList.toggle('ck-info--under-gallery',docked);
   if(this.gallery&&this.gallery!==gallery)this.gallery.classList.remove('ck-media-with-info');
   if(gallery)gallery.classList.toggle('ck-media-with-info',docked);
   this.gallery=gallery;
   this.relocating=false;
  }
  sync(){
   const desktop=this.media.matches;
   const list=this.querySelector('.ck-info__tabs');if(desktop)list.setAttribute('role','tablist');else list.removeAttribute('role');
   this.tabs.forEach((tab,index)=>{
    const selected=tab.dataset.tab===this.active,panel=this.panels[index];
    tab.setAttribute('role','tab');tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;
    panel.hidden=desktop&&!selected;
    if(desktop){panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tab.id);if(panel.tagName==='DETAILS')panel.open=true}
    else{panel.removeAttribute('role');panel.removeAttribute('aria-labelledby');if(panel.tagName==='DETAILS')panel.open=false}
   });
  }
  disconnectedCallback(){if(this.relocating)return;this.home?.remove();this.gallery?.classList.remove('ck-media-with-info');this.media?.removeEventListener('change',this.update);this.initialized=false}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
